import * as React from 'react';
import { DiMaskedInput } from '../DiComponents';

import { coalesceFieldErrors } from './utils';

export default function DiInputMaskAdapter(props) {
  const { input, meta, mask, ...inputProps } = props;
  let valid;
  if (meta.touched) {
    valid = coalesceFieldErrors(meta).length === 0;
  }
  return <DiMaskedInput {...input} {...inputProps} valid={valid} mask={mask} />;
}
